import { Card, CardBody, Col } from 'reactstrap'
import { ColumnCharts } from '../../../../Utils/Constants'
import ReactApexChart from 'react-apexcharts'
import { columnChartData } from '../../../../Data/Charts/ApexChart/ApexChartData'
import CommonCardHeader from '../../../../Utils/CommonComponents/CommonCardHeader/CommonCardHeader'

const FirstColumnChart = () => {
  return (
    <Col sm="12" xl="6" className="box-col-6">
      <Card>
        <CommonCardHeader title={ColumnCharts} />
        <CardBody>
          <div id="column-chart">
            <ReactApexChart options={columnChartData} series={columnChartData.series} type="bar" height={350} />
          </div>
        </CardBody>
      </Card>
    </Col>
  )
}

export default FirstColumnChart